// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const morePropTypes = require('client-v2/common/utils/prop-types')
// Shared imports
const BemEntity = require('shared/bem')

const bem = BemEntity('InputCheckbox')

function InputCheckbox(props) {
  const { className, inputRef, ...inputProps } = props
  return (
    tag('div', {
      className: classNames(
        bem.block(),
        className
      )
    },
      tag('input', {
        ref: inputRef,
        className: bem.element('input'),
        type: 'checkbox',
        ...inputProps
      }),
      tag('label', {
        className: bem.element('label')
      })
    )
  )
}

InputCheckbox.propTypes = {
  // Values
  className: PropTypes.string,
  inputRef: morePropTypes.domRef
  // Passes all other props down to input[type=checkbox] element
}

module.exports = InputCheckbox
